import React from 'react';
import { Theme } from '@material-ui/core';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';

import { colorPalette } from '../styles/customStyling';

const styles = (theme: Theme) => ({
  mainContainer: {
    fontWeight: 300,
    color: colorPalette.white,
    backgroundColor: colorPalette.blueExtraDark,
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center',
    textAlign: 'center' as 'center',
    margin: 'auto',
    minHeight: 400,
    paddingTop: theme.spacing(7),
    paddingBottom: theme.spacing(15),
    [theme.breakpoints.down('xs')]: {
      paddingBottom: theme.spacing(7)
    }
  },
  orangeDot: {
    color: colorPalette.slOrange
  },
  firstParagraph: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    fontSize: 32,
    [theme.breakpoints.down('xs')]: {
      fontSize: 20
    }
  },
  secondParagraph: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    fontSize: 18,
    [theme.breakpoints.down('xs')]: {
      fontSize: 16
    }
  }
});

// Start typescript definitions
interface OwnProps extends WithStyles<typeof styles> {
  userEmail?: string;
}
// End typescript definitions

export const SuccessPage = (props: OwnProps) => (
  <div className={props.classes.mainContainer}>
    <p className={props.classes.firstParagraph}>
      Thank you! Your application will be reviewed by our staff
      <span className={props.classes.orangeDot}>.</span>
    </p>
    <p className={props.classes.secondParagraph}>
      A confirmation email with log in information was sent to <b>{props.userEmail || 'you'}</b>
      <br />
      By logging in, you can view the status of your application.
    </p>
  </div>
);

export default withStyles(styles)(SuccessPage);
